<template>
    <div class="color-picker" :class="isDarkColor ? 'white-font' : 'black-font'">
      <el-input
        v-bind="$attrs"
        v-bind:value="value"
        v-on="changeListeners"
        maxlength="7"
        :style="`background-color: ${value}; color: ${isDarkColor} ? #fff : #000`"
      />
      <el-color-picker
        v-bind="$attrs"
        v-bind:value="value"
        v-on="changeListeners"
      ></el-color-picker>
    </div>
</template>

<script>
import { getContrastYIQ } from "./static";

export default {
  name: "ColorPicker",
  props: {
    value: {
      required: true,
      type: String,
    }
  },
  data() {
    return {
    };
  },
  computed: {
    changeListeners() {
      const vm = this;
      return Object.assign(
        {},
        this.$listeners,
        {
          input: function(_value) {
            vm.$emit("input", _value);
          },
          change: function(_value) {
            vm.$emit("change", _value);
          }
        }
      );
    },
    isDarkColor() {
      return getContrastYIQ(this.value) === "dark";
    }
  },
  methods: {

  }
};
</script>
